//Global search - FETCH Search history
export const FETCH_SEARCH_HISTORY = "global-search/FETCH_SEARCH_HISTORY";

//Global search - SAVE Search TO history
export const SAVE_SEARCH_TO_HISTORY = "global-search/SAVE_SEARCH_TO_HISTORY";

export type Action =
	| { type: FETCH_SEARCH_HISTORY }
	| { type: SAVE_SEARCH_TO_HISTORY };



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearch/actions/action-types.js